import { Component, OnDestroy, OnInit } from '@angular/core';
import { MapService } from 'src/app/shared/layout/fap_main-map/service/map-service';

@Component({
  selector: 'print-excel',
  templateUrl: './print-excel.component.html',
  styleUrls: ['./print-excel.component.scss']
})
export class PrintExcelComponent implements OnInit, OnDestroy {

  constructor(public mapService: MapService) { }

  ngOnInit(): void {
    this.mapService.hideMap();
  }

  ngOnDestroy(): void {
    this.mapService.showMap();
  }

}
